import React from 'react';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import { Flex } from 'components/layout/Flex';
import { useRecoilValue } from 'recoil';
import { lookupState } from 'state/atoms';
import { LookupView } from 'pages/NewCaseSearch/LookupView';
import { DIFFERENT_ACCOUNT_STATUS, LOOKUP_UI_RMA_SCRAPPED_STATE } from 'utils/constants';
import PartNotFoundMessage from 'pages/NewCaseSearch/subcomponents/PartNotFoundMessage';
import { SelectPartMessage } from 'pages/NewCaseSearch/subcomponents/VisualComponents';

const getSelectionMessage = (selectedResult) => {
  if (selectedResult && selectedResult.status === LOOKUP_UI_RMA_SCRAPPED_STATE) {
    return 'Serial Number Reported as Scrapped. Not RMA Eligible';
  }

  return selectedResult && selectedResult.status === DIFFERENT_ACCOUNT_STATUS
    ? `Our records indicate serial number ${selectedResult.serialNumber}, part number ${selectedResult.product.partNumber} belongs to account ${selectedResult.customerName}. If you believe this is incorrect, please proceed Add To RMA noting all applicable info.`
    : null;
};

const AssociatedPartNumber = ({ serialNumber }) => (
  <SelectPartMessage>
    <p>
      {`This part number is already associated with serial number ${serialNumber}. Please select this part number from the dropdown to proceed.`}
    </p>
  </SelectPartMessage>
);

const NotSearchedMessage = () => (
  <SelectPartMessage>
    <p>
      Please, select a part number to proceed or search for your part number if it's not in the
      list.
    </p>
  </SelectPartMessage>
);

const MultipleParts = () => {
  const currentLookupState = useRecoilValue(lookupState);
  const { lookupResults, selectedResult, searchedPartNumber, reviewRequested } = currentLookupState;
  const { serialNumber } = lookupResults[0];
  const serialNumberCard = [{ title: 'Serial #:', value: serialNumber }];
  const reviewCard = reviewRequested ? [{ title: 'Requested Review:', value: 'True' }] : [];
  const selectionMessage = getSelectionMessage(selectedResult);

  const renderFeedbackMessage = () => {
    // Selected a result or searched for a valid product
    if (selectedResult) {
      return <LookupView status={selectedResult.status} lookupResults={lookupResults} />;
    }

    // Needs to search (no term yet provided)
    if (!searchedPartNumber) {
      return <NotSearchedMessage />;
    }

    // If the searched term matches a result from the lookup response,
    // present a specific message
    const associatedPart = lookupResults
      .filter((result) => result.product)
      .find((result) => result.product.partNumber === searchedPartNumber);

    if (associatedPart) {
      return <AssociatedPartNumber serialNumber={lookupResults[0].serialNumber} />;
    }

    // Has a search term but not a result - not found
    return <PartNotFoundMessage searchedPartNumber={searchedPartNumber} />;
  };

  return (
    <Flex direction="column">
      <Header
        title="Serial Number Associated With Multiple Items"
        subtitle={`Your serial number ${serialNumber} is associated with multiple part numbers. Please specify the part number you want included in your RMA request.`}
        parts={lookupResults}
        cards={[...serialNumberCard, ...reviewCard]}
        selectionMessage={selectionMessage}
        withLookup={currentLookupState.presentPartSearch}
      />
      {renderFeedbackMessage()}
    </Flex>
  );
};

export default MultipleParts;
